import {ValueObject} from '@s-ui/domain'

export class ReservationClientSecretTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.clientSecret
   */
  #clientSecret

  constructor({clientSecret}) {
    super()
    this.#clientSecret = clientSecret
  }

  getClientSecret = () => this.#clientSecret

  static create = ({clientSecret}) => {
    return new ReservationClientSecretTransactionsValueObject({clientSecret})
  }

  toJSON = () => {
    return {
      clientSecret: this.#clientSecret
    }
  }
}
